import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/circleci/project/apps/sb-shell/app/(darkHeader)/voiceover/VoiceoverContainer.tsx");
